import { NotificationModel } from '../../models';

export interface NotificationsState {
  notifications: NotificationModel[];
}

export const InitialNotificationsState: NotificationsState = {
  notifications: [],
};
